import { Injectable } from "@angular/core";
import { PopoverController } from "ionic-angular";

@Injectable()
export class PopoverProvider {
  constructor(
    public popoverCtrl: PopoverController
  ) {}

  show(page: string, data?:{}, addCss:string = "", callback:any = () => {}): void {
    const popover = this.popoverCtrl.create(page, data, { showBackdrop: true, enableBackdropDismiss: true, cssClass: addCss });
    popover.onDidDismiss(callback);
    popover.present();
  }

  // NOTE: 他プロパイダーから呼ぶと表示位置が真ん中より下になるため注意。
  showWithCenter(page: string, data?:{}, addCss:string = "", callback:any = () => {}): void {
    const popover = this.popoverCtrl.create(
        page,
        data,
        { 
            showBackdrop: true,
            enableBackdropDismiss: true,
            cssClass: "center-popover " + addCss 
        }
    );
    popover.onDidDismiss(callback);
    const ev = { 
      target : { 
        getBoundingClientRect : () => { 
          return { 
            left: '0',
            right: '0'
          }; 
        } 
      },
      animate: false
    };
    popover.present({ev});
  }

  showWithCenterWebToApp(data?:{}, addCss:string = "", callback:any = () => {}): void {
    const popover = this.popoverCtrl.create(
        "WebToAppPopoverPage",
        data,
        { 
            showBackdrop: true,
            enableBackdropDismiss: true,
            cssClass: "center-popover-for-webtoapp " + addCss 
        }
    );
    popover.onDidDismiss(callback);
    const ev = { 
      target : { 
        getBoundingClientRect : () => { 
          return { 
            left: '0',
            right: '0'
          }; 
        } 
      },
      animate: false
    };
    popover.present({ev});
  }

  showWithCenterQrcode(data?:{}, addCss:string = "", callback:any = () => {}): void {
    const popover = this.popoverCtrl.create(
        "QrcodePopoverPage",
        data,
        { 
            showBackdrop: true,
            enableBackdropDismiss: true,
            cssClass: "center-popover-for-qrcode " + addCss 
        }
    );
    popover.onDidDismiss(callback);
    const ev = { 
      target : { 
        getBoundingClientRect : () => { 
          return { 
            left: '0',
            right: '0'
          }; 
        } 
      },
      animate: false
    };
    popover.present({ev});
  }
}



// WEBPACK FOOTER //
// ./src/providers/popover/popover.ts